import dateformat from 'dateformat'

window.serverTimeToLocal = (serverTime) => {
  if(!serverTime || serverTime === "0001-01-01T00:00:00Z") return ''; // golang time zero
  const date = new Date(serverTime); // already in UTC
  return dateformat(date, "yyyy-mm-dd HH:MM");
}

window.serverTimeToLocalFormat = (serverTime, format) => {
  if(!serverTime || serverTime === "0001-01-01T00:00:00Z") return ''; // golang time zero
  const date = new Date(serverTime); // already in UTC
  return dateformat(date, format);
}

window.safeDate = (oldStringDate, newRealDate) => {
  return oldStringDate ? oldStringDate : serverTimeToLocal(newRealDate);
}

window.newSafeDate = (stringDate) => {
  if(!stringDate) return new Date();
  return new Date(stringDate);
}

window.initDatePickers = (selector, defaultDate) => {
  const config = {
    format: 'YYYY-MM-DD HH:mm',
    icons: {
      time: "fa fa-clock-o",
      date: "fa fa-calendar",
      up: "fa fa-chevron-up",
      down: "fa fa-chevron-down",
      previous: 'fa fa-chevron-left',
      next: 'fa fa-chevron-right',
      today: 'fa fa-screenshot',
      clear: 'fa fa-trash',
      close: 'fa fa-remove'
    }
  };

  if(defaultDate) config.defaultDate = defaultDate;

  $(selector).datetimepicker(config);

  // manually fire events so they work with Vue
  const triggerEvent = (e) => {
    var formattedValue = e.date.format(e.date._f);
    console.log(formattedValue);

    var event = document.createEvent('HTMLEvents');
    event.initEvent('input', true, true);
    e.target.dispatchEvent(event);
  };

  $(selector).on('dp.change', triggerEvent);
  $(selector).on('dp.hide', triggerEvent);
};


// WEBPACK FOOTER //
// ./src/utils/date.js